import React, { useState } from 'react';
import { useAppSelector } from '../../../redux/hooks';
import WorkspaceLink from './WorkspaceLink';

/**
 * We can't use SecondaryNavLinks component because
 * each workspace link can have highlights with custom SVG element
 */
export default () => {
  const [mouseOverLink, setMouseOverLink] = useState('');

  const workspaceList = useAppSelector(
    (state) => state.workspaces.workspaceList,
  );

  return (
    <>
      {workspaceList.map(({ id, name }) => (
        <WorkspaceLink
          key={`workspace-nav-link-${id}`}
          name={name}
          id={id}
          mouseOverLink={mouseOverLink}
          setMouseOverLink={setMouseOverLink}
        />
      ))}
    </>
  );
};
